import kformUtils from '../../utils/kform-utils';
const isNumeric = (/** @type {any} */ n) => !Number.isNaN(Number.parseFloat(n)) && Number.isFinite(n);

export default /* @ngInject */ (/** @type {any} */ $scope) => {
	$scope.maskOptions = {
		padFractionalZeros: $scope.component.requireDecimal,
		scale:              $scope.component.decimalLimit,
	};

	if ($scope.options?.building) {
		return;
	} // FOR-71 - Skip parsing input data.

	// Ensure that values are numbers.
	if ($scope.data && Object.prototype.hasOwnProperty.call($scope.data, $scope.component.key)) {
		$scope.$watch('component.defaultValue', () => {
			for (const index in $scope.data[$scope.component.key]) {
				if ($scope.data[$scope.component.key][index].qty === undefined) {
					$scope.data[$scope.component.key][index] = {
						qty:  $scope.component.defaultValue.qty,
						unit: $scope.component.defaultValue.unit,
					};
				}
			}
		}, true);

		$scope.$watch('readOnly', (/** @type {boolean} */ readOnly) => {
			if (readOnly === false && $scope.data[$scope.component.key].length < $scope.component.validate.card.to) {
				$scope.data[$scope.component.key].push({
					qty:  $scope.component.defaultValue.qty,
					unit: $scope.component.defaultValue.unit,
				});
			}
		});

		for (const [index, value] of $scope.data[$scope.component.key].entries()) {
			if (!isNumeric(value.qty)) {
				$scope.data[$scope.component.key][index].qty = Number.parseFloat(value);
			}
		}
	}

	$scope.changeValue = () => {
		if (typeof $scope.component.event.onChange === 'string') {
			const custom = ''.concat($scope.component.event.onChange, '; ');
			kformUtils.evaluate(custom, {
				data: $scope.data,
				form: $scope.form,
			});
		}
	};
};
